/**
 * 재방문 마일리지 거래 타입 (d2c_mileage_transaction.type).
 * 원장(append-only) 기록으로, 잔액은 원장의 합으로 검증한다.
 */
export var MileageTransactionType;
(function (MileageTransactionType) {
    /** 예약 이용완료(반납) 후 적립 (결제액의 1%) */
    MileageTransactionType["EARN"] = "EARN";
    /** 결제 시 사용(차감) */
    MileageTransactionType["USE"] = "USE";
    /** 유효기간(12개월) 만료 소멸 */
    MileageTransactionType["EXPIRE"] = "EXPIRE";
    /** 친구추천 보상 적립 */
    MileageTransactionType["REFERRAL"] = "REFERRAL";
    /** 소급 웰컴 캠페인 적립 (1회성) */
    MileageTransactionType["WELCOME"] = "WELCOME";
    /** 예약 취소/환불 시 적립·사용 원복(회수) */
    MileageTransactionType["CANCEL_CLAWBACK"] = "CANCEL_CLAWBACK";
})(MileageTransactionType || (MileageTransactionType = {}));
